<template>
  <div class="structure">
      <div class="jiegou-input">
        <span class="trend-title">录入方式</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="jiegou-input">
        <span class="trend-title">全年总能耗</span>
        <el-input type="number" placeholder="请输入" v-model="coalT">
          <template slot="suffix">吨标煤</template>
        </el-input>
      </div>
      <div class="jiegou-input">
        <span class="trend-title">市电占比</span>
        <el-input type="number" placeholder="请输入" v-model="cityTage">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="jiegou-input">
        <span class="trend-title">风电占比</span>
        <el-input type="number" placeholder="请输入" v-model="windTage">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="jiegou-input">
        <span class="trend-title">余热电占比</span>
        <el-input type="number" placeholder="请输入" v-model="lastHotTage">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="jiegou-input">
        <span class="trend-title">光伏电占比</span>
        <el-input type="number" placeholder="请输入" v-model="lightTage">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="jiegou-input">
        <span class="trend-title">绿色能源总占比</span>
        <el-input type="number" placeholder="请输入" v-model="greenTage">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="last-save">
         <el-button size="small" :loading="structLoading" type="primary" @click="saveStructure">保存</el-button>
      </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      structLoading:false,//加载状态
      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],
      value:1,

      //数据
      coalT:'',//吨标煤
      cityTage:'',//市电占比
      windTage:'',//风电占比
      lastHotTage:'',//余热电占比
      lightTage:'',//光伏电占比
      greenTage:'',//绿色能源总占比
      linshiID:'',
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    //获取数据
    getList(){
      apis.getStructure().then(res=>{
        if(res.code==10000){
          let _data = res.data
          this.coalT = _data.totalEnergy
          this.lastHotTage = _data.afterheatMix
          this.greenTage = _data.greenMix
          this.lightTage = _data.lightMix
          this.cityTage = _data.marketMix
          this.windTage = _data.windMix
          this.linshiID = _data.id
        }
      })
    },
    //保存数据
    saveStructure(){
      this.structLoading = true;
      let obj = {
        totalEnergy:this.coalT,
        afterheatMix:this.lastHotTage,
        greenMix:this.greenTage,
        lightMix:this.lightTage,
        marketMix:this.cityTage,
        windMix:this.windTage,
      }
      if(this.linshiID){
        obj.id = this.linshiID
      }
      apis.saveStructure(obj).then(res=>{
        if(res.code==10000){
          this.structLoading = false;
          this.$message.success('保存成功');
        }else{
          this.structLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.structure{ padding-top: 10px;
  .jiegou-input{ margin-bottom: 15px;
    .trend-title{ width: 8.35rem;}
    .el-input,.el-select{ display: inline-block; width: 15rem;}
  }
}
</style>